export const BENCHMARK = "benchmark";
export const VARIATIONS = "variations";